import * as types from './actionTypes';
import { getRequest, postRequest, putRequest, patchRequest, deleteRequest } from '../../lib/apiUtils';
import { flattenObj } from '../../lib/utils';
import { getPartialSystemSettings } from './SettingsActions';
import { PartialSettings } from '../../lib/constants';
import { CampaignListStatuses } from '../../lib/systemVariables';
import _orderBy from "lodash/orderBy";

export function getCampaigns() {
    return async dispatch => {
        dispatch({ type: types.START_GET_CAMPAIGNS });

        let response = await getRequest("/campaigns");
        response.data = response.data.records ? response.data.records.map(campaign => ({ key: campaign.campaignId, value: campaign.name })) : [];

        dispatch({ type: types.GET_CAMPAIGNS, response });
    }
}

export function updateFilters(update) {
    return dispatch => {
        dispatch({ type: types.UPDATE_CAMPAIGNS_FILTERS, update });
    }
}

export function updateTable(settings) {
    return dispatch => {
        dispatch({ type: types.UPDATE_CAMPAIGNS_TABLE, settings });
    }
}

export function getCampaignRecords(page = 1, results = 12, sort = { by: 'status', direction: 'Descending' }) {
    return async (dispatch, getState) => {
        const settings = { page, results, sort };
        dispatch({ type: types.UPDATE_CAMPAIGNS_TABLE, settings });

        const requestId = ++getState().campaignsTable.currentRequestId;
        dispatch({ type: types.START_GET_CAMPAIGNS_TABLE_RECORDS, requestId });

        const tableSettings = getState().campaignsTable;
        const filterSettings = getState().campaigns.filters;
        let params = {
            verbose: true,
            page: tableSettings.page,
            sortBy: tableSettings.sort.by,
            sortDirection: tableSettings.sort.direction,
            results: tableSettings.resultsView
        };
        for (var filterProperty in filterSettings) {
            let filterVal = filterSettings[filterProperty];
            params[filterProperty] = filterVal;
        }

        const response = await getRequest('/campaigns', params);

        dispatch({ type: types.GET_CAMPAIGNS_TABLE_RECORDS, ...{ response, requestId } });
    };
}

export function createCampaign(campaign) {
    return async dispatch => {
        dispatch({ type: types.START_CREATE_CAMPAIGN });

        const response = await postRequest("/campaigns", campaign);

        dispatch({ type: types.CREATE_CAMPAIGN, response });

        if (response.success) {
            dispatch(getCampaigns());
            dispatch(getPartialSystemSettings(PartialSettings.CampaignSettings))
        }
    };
}

export function getCampaignDetails(campaignId, verbose = true) {
    return async dispatch => {
        dispatch({ type: types.START_GET_CAMPAIGN_DETAILS });

        const response = await getRequest(`/campaigns/${campaignId}`, { verbose });
        dispatch({ type: types.GET_CAMPAIGN_DETAILS, response });
    };
}

export function clearCampaignDetails() {
    return dispatch => {
        dispatch({ type: types.CLEAR_CAMPAIGN_DETAILS });
        dispatch({ type: types.CLEAR_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS });
        dispatch({ type: types.CLEAR_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS });
        dispatch(updateIndividualsTable({ search: '' }));
        dispatch(updateListsTable({ statusFilter: '' }));
    };
}

export function updateCampaign(campaign) {
    return async dispatch => {
        dispatch({ type: types.START_UPDATE_CAMPAIGN_DETAILS });

        const { campaignId, endDate, approverId, maxAmount } = campaign;
        let response = await putRequest(`/campaigns/${campaignId}`, { endDate, maxAmount, approverId });

        if (response.success) {
            const updatedCampaign = await getRequest(`/campaigns/${campaignId}`);
            response.data = updatedCampaign.data;
        }

        dispatch({ type: types.UPDATE_CAMPAIGN_DETAILS, response });
    };
}

export function getCampaignAllLists(campaignId) {
    return async dispatch => {
        dispatch({ type: types.START_GET_CAMPAIGN_ALL_LISTS });

        let response = await getRequest(`/campaigns/${campaignId}/lists`);
        response.data = response.data ? response.data.records || [] : [];

        dispatch({ type: types.GET_CAMPAIGN_ALL_LISTS, response });
    };
}

export function getCampaignAllIndividuals(campaignId) {
    return async dispatch => {
        dispatch({ type: types.START_GET_CAMPAIGN_ALL_INDIVIDUALS });

        let response = await getRequest(`/campaigns/${campaignId}/individuals`);
        response.data = response.data ? response.data.records || [] : [];

        dispatch({ type: types.GET_CAMPAIGN_ALL_INDIVIDUALS, response });
    };
}

function getUpdatedCampaignDetails(campaignId) {
    return async dispatch => {
        const response = await getRequest(`/campaigns/${campaignId}`);
        dispatch({ type: types.GET_CAMPAIGN_DETAILS, response });
    }
}

//INDIVIDUALS:
export function updateIndividualsTable(settings) {
    return dispatch => {
        dispatch({ type: types.UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE, settings });
    }
}

export function getIndividuals(campaignId, page = 1, results = 12, sort = { by: 'name', direction: 'Ascending' }) {
    return async (dispatch, getState) => {
        if (getState().campaignDetailsIndividualsTable.selected.length)
            dispatch({ type: types.CLEAR_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_SELECTION });

        const settings = { page, results, sort };
        dispatch({ type: types.UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE, settings });

        const requestId = ++getState().campaignDetailsIndividualsTable.currentRequestId;
        dispatch({ type: types.START_GET_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS, requestId });

        const tableSettings = getState().campaignDetailsIndividualsTable;
        let params = {
            page: tableSettings.page,
            sortBy: tableSettings.sort.by,
            sortDirection: tableSettings.sort.direction,
            results: tableSettings.resultsView,
            search: tableSettings.search
        };

        const response = await getRequest(`/campaigns/${campaignId}/individuals`, params);

        dispatch({ type: types.GET_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS, ...{ response, requestId } });
    };
}

export function addIndividual(campaignId, recipientId, bypassError, campaignApplication) {
    return async dispatch => {
        dispatch({ type: types.START_ADD_CAMPAIGN_DETAILS_INDIVIDUAL });

        const formData = new FormData();
        const flatObj = flattenObj({ recipientId, ...campaignApplication });
        for (const prop in flatObj) formData.append(prop, flatObj[prop] !== null ? flatObj[prop] : '');
        campaignApplication.attachments.map(attachment => formData.append('attachments', attachment));

        const response = await postRequest(`/campaigns/${campaignId}/individuals?bypassError=${bypassError}`, formData);

        dispatch({ type: types.ADD_CAMPAIGN_DETAILS_INDIVIDUAL, response });

        if (response.success) dispatch(getUpdatedCampaignDetails(campaignId));
    };
}

export function updateIndividual(campaignId, recipientId, applicationId, update) {
    return async (dispatch, getState) => {
        dispatch({ type: types.START_UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD, recordId: recipientId });

        const patchUpdate = {};
        if(update.amount) patchUpdate.amount = update.amount;
        if(update.individualCategoryId) patchUpdate.individualCategoryId = update.individualCategoryId;
        if(update.fundId) patchUpdate['paymentInfo/fundId'] = update.fundId;

        let response = await patchRequest(`/applications/${applicationId}`, patchUpdate);
        response.recordIdKey = "recipientId";
        response.recordId = recipientId;
        response.update = update;

        dispatch({ type: types.UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD, response });

        if (response.success) {
            dispatch(getUpdatedCampaignDetails(campaignId));
            //TODO: re-requesting records, for now.  Will add request to get single indiv on campaign /campaigns/{id}/individuals/{id}.
            const tableSettings = getState().campaignDetailsIndividualsTable;
            dispatch(getIndividuals(campaignId, tableSettings.page, tableSettings.resultsView, tableSettings.sort));
        }
    };
}

export function removeIndividual(campaignId, recipientId) {
    return async dispatch => {
        dispatch({ type: types.START_REMOVE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD, recordId: recipientId });

        let response = await deleteRequest(`/campaigns/${campaignId}/individuals/${recipientId}`);
        response.recordIdKey = "recipientId";
        response.recordId = recipientId;

        dispatch({ type: types.REMOVE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD, response });

        if (response.success) dispatch(getUpdatedCampaignDetails(campaignId));
    };
}

export function deleteCampaign(campaignId) {
    return async dispatch => {
        dispatch({ type: types.DELETE_CAMPAIGN, result: { loading: true } });
        const result = await deleteRequest(`/campaigns/${campaignId}`);
        dispatch({ type: types.DELETE_CAMPAIGN, result });
    };
}


export function toggleSelectIndividual(recipient) {
    return dispatch => {
        dispatch({ type: types.TOGGLE_SELECT_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD, ...{ record: recipient, recordIdKey: 'recipientId' } });
    }
}

//LISTS:
export function updateListsTable(settings) {
    return dispatch => {
        dispatch({ type: types.UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE, settings });
    }
}

export function getLists(campaignId, page = 1, results = 12, sort = { by: 'name', direction: 'Ascending' }) {
    return async (dispatch, getState) => {
        const settings = { page, results, sort };
        dispatch({ type: types.UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE, settings });

        const requestId = ++getState().campaignDetailsListsTable.currentRequestId;
        dispatch({ type: types.START_GET_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS, requestId });

        const tableSettings = getState().campaignDetailsListsTable;
        let params = {
            page: tableSettings.page,
            sortBy: tableSettings.sort.by,
            sortDirection: tableSettings.sort.direction,
            results: tableSettings.resultsView,
            status: tableSettings.statusFilter,
            keyword: tableSettings.keyword
        };

        const response = await getRequest(`/campaigns/${campaignId}/lists`, params);

        dispatch({ type: types.GET_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS, ...{ response, requestId } });
    };
}

export function addList(campaignId, listId, emailMessage, defaultAmount, bypassError) {
    return async dispatch => {
        dispatch({ type: types.START_ADD_CAMPAIGN_DETAILS_LIST });

        const response = await postRequest(`/campaigns/${campaignId}/lists?bypassError=${bypassError}`,
            { listId, emailMessage, defaultAmount, url: `${window.location.origin}/external-lists/${listId}` });

        dispatch({ type: types.ADD_CAMPAIGN_DETAILS_LIST, response });

        if (response.success) dispatch(getUpdatedCampaignDetails(campaignId));
    };
}

export function updateList(campaignId, campaignListId, update) {
    return async (dispatch, getState) => {
        dispatch({ type: types.START_UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD, recordId: campaignListId });

        let response = await patchRequest(`/campaigns/${campaignId}/lists/${campaignListId}`, update);
        response.recordIdKey = "campaignListId";
        response.recordId = campaignListId;
        response.update = update;

        dispatch({ type: types.UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD, response });

        if (response.success) {
            dispatch(getUpdatedCampaignDetails(campaignId));
            //TODO: re-requesting records, for now.  Will add request to get single list on campaign /campaigns/{id}/lists/{id}.
            const tableSettings = getState().campaignDetailsListsTable;
            dispatch(getLists(campaignId, tableSettings.page, tableSettings.resultsView, tableSettings.sort));
        }
    };
}

export function removeList(campaignId, campaignListId) {
    return async dispatch => {
        dispatch({ type: types.START_REMOVE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD, recordId: campaignListId });

        let response = await deleteRequest(`/campaigns/${campaignId}/lists/${campaignListId}`);
        response.recordIdKey = "campaignListId";
        response.recordId = campaignListId;

        dispatch({ type: types.REMOVE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD, response });

        if (response.success) dispatch(getUpdatedCampaignDetails(campaignId));
    };
}

export function getCampaignListExternalUpdates(campaignListId) {
    return async dispatch => {
        dispatch({ type: types.START_GET_CAMPAIGN_LIST_EXTERNAL_UPDATES });

        let response = { loading: false, success: true, data: {} };

        const updatedParticipants = await getRequest(`/campaignlists/${campaignListId}/updatedParticipants`, null, []);

        const removedParticipants = await getRequest(`/campaignlists/${campaignListId}/removedParticipants`, null, []);

        const addedParticipants = await getRequest(`/campaignlists/${campaignListId}/addedParticipants`, null, []);

        response.success = updatedParticipants.success && removedParticipants.success && addedParticipants.success;
        response.data = {
            updatedParticipants: updatedParticipants.data,
            removedParticipants: removedParticipants.data,
            addedParticipants: addedParticipants.data
        };

        dispatch({ type: types.GET_CAMPAIGN_LIST_EXTERNAL_UPDATES, response });
    }
}

export function getReceivingParticipants(campaignListId, newParticipants, reset = false, page = 1, results = 12,
                                         sort = { by: 'name', direction: 'Ascending' }) {
    return async (dispatch, getState) => {
        const configs = { page, results, sort };
        dispatch({ type: types.UPDATE_RECEIVING_PARTICIPANTS_INFINITELIST_CONFIGS, configs });

        const requestId = ++getState().receivingParticipantsTable.currentRequestId;
        dispatch({ type: types.START_GET_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS, requestId, reset: reset});

        const tableSettings = getState().receivingParticipantsTable;

        //need to get all records from db and do sorting on client side bec. replacing suggested name and position
        const response = await getRequest(`/campaignlists/${campaignListId}/receivingParticipants`);

        response.data.records = response.data.records.map(participant => {
            const id = participant.externalListMemberId.toString();
            const selectedSuggestion = newParticipants.filter(p => p.key.toString() === id && (p.value))[0];
            const name = selectedSuggestion ? selectedSuggestion.name : participant.name;
            const lastName = selectedSuggestion ? selectedSuggestion.lastName : participant.lastName;
            const orgEmployment = participant && participant.orgEmployment != "" ? participant.orgEmployment : selectedSuggestion ? selectedSuggestion.orgEmployment : '';
            participant.name = name;
            participant.lastName = lastName;
            participant.orgEmployment = orgEmployment;
            return participant;
        });

        response.data.records = _orderBy(response.data.records, 
            tableSettings.sort.by === 'position' ? 'orgEmployment' : 
                tableSettings.sort.by === 'name' ? 'lastName' : tableSettings.sort.by,
            tableSettings.sort.direction === 'Descending' ? 'desc' : 'asc');

        response.data.records = response.data.records.slice((page - 1) * results, page * results);

        dispatch({ type: types.GET_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS, ...{ response, requestId } });
    };
}

export function clearReceivingParticipants() {
    return dispatch => {
        dispatch({ type: types.CLEAR_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS });
    };
}

export function verifyCampaignListExternalUpdates(campaignId, campaignListId, newParticipants, rejectedParticipants,
    defaultAmount, bypassError) {
    return async dispatch => {
        dispatch({ type: types.START_VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES });

        const response = await postRequest(`/campaignLists/${campaignListId}/pendingChanges/verify?bypassError=${bypassError}`,
            { newParticipants, rejectedParticipants, campaignId, defaultAmount });

        dispatch({ type: types.VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES, response });
    };
}

export function approveCampaignList(campaignId, campaignListId) {
    return async dispatch => {
        dispatch({ type: types.START_APPROVE_CAMPAIGN_DETAILS_LIST });

        const response = await postRequest(`/campaigns/${campaignId}/lists/${campaignListId}/approve`);

        dispatch({ type: types.APPROVE_CAMPAIGN_DETAILS_LIST, response });

        if (response.success) {
            let updatedCampaignList = {
                success: response.success,
                recordIdKey: "campaignListId",
                recordId: campaignListId,
                update: { status: CampaignListStatuses.Approved }
            };

            dispatch({ type: types.UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD, ...{ response: updatedCampaignList } });
        }
    };
}

export function resendExternalCampaignListMessage(campaignId, campaignListId) {
    return async dispatch => {
        dispatch({ type: types.START_RESEND_CAMPAIGN_DETAILS_LIST });

        const response = await postRequest(`/campaigns/${campaignId}/lists/${campaignListId}/resendMessage`,
            { url: `${window.location.origin}/external-lists/${campaignListId}` });

        dispatch({ type: types.RESEND_CAMPAIGN_DETAILS_LIST, response });
    };
}

export function updateCampaignListApplicationsTable(settings) {
    return dispatch => {
        dispatch({ type: types.UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE, settings });
    };
}

export function clearCampaignListApplications() {
    return dispatch => {
        dispatch({ type: types.CLEAR_CAMPAIGN_LIST_DETAILS });
        dispatch({ type: types.CLEAR_CAMPAIGN_DETAILS });
        dispatch({ type: types.CLEAR_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS });
        dispatch({ type: types.CLEAR_CAMPAIGN_LISTS_APPLICATIONS_STATUS});
    };
}

export function getCampaignListApplications(campaignId, campaignListId, page = 1, results = 12, sort = { by: 'lastName', direction: 'Ascending' }) {
    return async (dispatch, getState) => {
        const settings = { page, results, sort };
        dispatch({ type: types.UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE, settings });

        const requestId = ++getState().campaignListApplicationsTable.currentRequestId;
        dispatch({ type: types.START_GET_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS, requestId });

        const tableSettings = getState().campaignListApplicationsTable;
        const applicationStatus = getState().campaignListApplications.applicationStatus;
        let params = {
            page: tableSettings.page,
            sortBy: tableSettings.sort.by,
            sortDirection: tableSettings.sort.direction,
            results: tableSettings.resultsView,
            applicationStatus
        };

        const response = await getRequest(`/campaigns/${campaignId}/lists/${campaignListId}/applications`, params);

        dispatch({ type: types.GET_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS, ...{ response, requestId } });
    };
}

export function updateCampaignListApplicationsStatus(applicationStatus) {
    return dispatch => {
        dispatch({ type: types.UPDATE_CAMPAIGN_LISTS_APPLICATIONS_STATUS, applicationStatus });
    }
}

export function updateCampaignListApplication(application, update) {
    return async dispatch => {
        dispatch({ type: types.START_UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD, recordId: application.applicationId });

        const response = await patchRequest(`/applications/${application.applicationId}`, update);
        response.recordIdKey = 'applicationId';
        response.recordId = application.applicationId;
        response.update = { ...update }; 

        dispatch({ type: types.UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD, response });
    };
}

export function updateApplicationStatus(action, applications) {
    const applicationId = applications[0].applicationId;
    return async dispatch => {
        dispatch({ type: types.START_UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD, recordId: applicationId });

        const response = await postRequest(`/applications/${action}`, applications);
        response.recordIdKey = 'applicationId';
        response.recordId = applicationId;

        dispatch({ type: types.UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD, response });
    };
}


// WEBPACK FOOTER //
// ./src/redux/actions/CampaignsActions.js